import * as Loadable from 'react-loadable'

import { selectItemCountForCategory } from '../../../common/selectors/categories'
import { IPageComponent } from '../../../typings/pageComponent'
import LoadingCover from '../../components/loadingCover'
import { getSearchLocationParams } from '../../../common/utils/location'
import { chooseContainer } from '../categoryProxyContainer'

import {
  fetchCategoryPageData,
  onBeforeCategoryPageView
} from '../../../common/actions/categoryPage'

const CategoryPageLoadableContainer = (Loadable as any)({
  loader: () =>
    import(/* webpackChunkName: "categoryPage" */ './categoryPageContainer'),
  loading: LoadingCover,
  webpack: () => [require.resolveWeak('./categoryPageContainer')],
  modules: ['./categoryPageContainer']
}) as IPageComponent<any>

CategoryPageLoadableContainer.onBeforePageView = ({ store, routeMatch }) => {
  return store.dispatch(onBeforeCategoryPageView({ routeMatch }))
}

CategoryPageLoadableContainer.loadData = ({
  store,
  location,
  apiAppUrlPrefix,
  routeMatch
}) => {
  const state = store.getState()
  const {
    common: { currentSite }
  } = state

  const locationParams = getSearchLocationParams({
    location,
    routeMatch,
    currentSite
  })

  const itemCount = selectItemCountForCategory(state, locationParams.category)

  const choosenContainer = chooseContainer({
    currentSite,
    query: location.query,
    locationParams,
    itemCount
  })

  if (choosenContainer === 'CategoryPageContainer') {
    return store.dispatch(
      fetchCategoryPageData({ location, apiAppUrlPrefix, locationParams })
    )
  }

  return Promise.resolve()
}

export default CategoryPageLoadableContainer
